import { CommandName, getFragment, } from "../../../../src/ipm/background";
import * as logger from "../../../utilities/background";
import { Timing } from "../timing.types";
import { defaultPriority, } from "./ipm-onpage-dialog.types";
function getParamDefinitionList() {
    const { isEmpty, isEmptyOrPositiveNumber, isNotEmpty, isValidDomainList, isSafeUrl, isValidLicenseStateList, } = getFragment();
    return [
        {
            name: "timing",
            validate: (param) => {
                if (typeof param !== "string") {
                    return false;
                }
                return (param === Timing.afterWebAllowlisting ||
                    param === Timing.revisitWebAllowlisted ||
                    param === Timing.afterNavigation ||
                    param === Timing.cookieBanner);
            },
        },
        {
            name: "display_duration",
            validate: (param) => typeof param === "undefined" || (typeof param === "number" && param >= 0 && param <= 20),
        },
        {
            name: "sub_title",
            validate: (param, commandVersion) => {
                if (commandVersion >= 8) {
                    return true;
                }
                return isNotEmpty(param);
            },
        },
        {
            name: "upper_body",
            validate: (param, commandVersion) => {
                if (commandVersion >= 8) {
                    return true;
                }
                return isNotEmpty(param);
            },
        },
        {
            name: "button_label",
            validate: (param, commandVersion) => {
                if (commandVersion >= 8) {
                    return true;
                }
                return isNotEmpty(param);
            },
        },
        {
            name: "button_target",
            validate: isSafeUrl,
        },
        {
            name: "domain_list",
            validate: isValidDomainList,
        },
        {
            name: "license_state_list",
            validate: isValidLicenseStateList,
        },
        {
            name: "priority",
            validate: isEmptyOrPositiveNumber,
        },
        {
            name: "lower_body",
            validate: (param, commandVersion) => {
                if (commandVersion >= 8) {
                    return true;
                }
                return typeof param === "undefined" || isNotEmpty(param);
            },
        },
        {
            name: "content",
            validate: (param, commandVersion) => {
                if (commandVersion < 8) {
                    return true;
                }
                if (param === null || typeof param !== "object") {
                    return false;
                }
                if (!("en" in param)) {
                    return false;
                }
                for (const content of Object.values(param)) {
                    if (!isDialogCommandContent(content)) {
                        return false;
                    }
                    if (isEmpty(content.button_label) ||
                        isEmpty(content.sub_title) ||
                        isEmpty(content.upper_body)) {
                        return false;
                    }
                    if (typeof content.lower_body !== "undefined" && isEmpty(content.lower_body)) {
                        return false;
                    }
                }
                return true;
            },
        },
    ];
}
function getBehavior(command) {
    var _a;
    if (!isDialogCommand(command)) {
        return null;
    }
    return {
        displayDuration: typeof command.display_duration === "number" ? command.display_duration : 5,
        target: command.button_target,
        timing: command.timing,
        domainList: command.domain_list,
        licenseStateList: (_a = command.license_state_list) !== null && _a !== void 0 ? _a : getFragment().defaultLicenseState,
        priority: typeof command.priority === "number" ? command.priority : defaultPriority,
    };
}
function getContent(command, content) {
    if (!isDialogCommand(command) || !isDialogCommandContent(content)) {
        return null;
    }
    return {
        body: typeof content.lower_body === "string"
            ? [content.upper_body, content.lower_body]
            : [content.upper_body],
        button: content.button_label,
        title: content.sub_title,
    };
}
function isDialogCommand(command) {
    const validationErrors = getFragment().validateParams(command, getParamDefinitionList());
    if (validationErrors.length === 0) {
        return true;
    }
    logger.error("[onpage-dialog]: Invalid parameters received:", validationErrors.join(" "));
    return false;
}
function isDialogCommandContent(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "button_label" in candidate &&
        "sub_title" in candidate &&
        "upper_body" in candidate);
}
export function setDialogCommandHandler(handler, clearCommands) {
    getFragment().setCommandActor(CommandName.createOnPageDialog, {
        clearCommands,
        getBehavior,
        getContent,
        handleCommand: handler,
        isValidCommand: isDialogCommand,
        onCommandsProcessed: () => { },
    });
}
